import React from 'react';
import {Typography} from "@mui/material";
import BottomBorder from "../BottomBorder";
import {AiMentionsProseContent} from "../../models/AiMentionsContent";

interface ProofProps {
    content: AiMentionsProseContent;
}

// Decorative process chip - three stroke icons with arrows between them. No real
// data sits behind it, hence aria-hidden on the card.
const Proof: React.FC<ProofProps> = ({content}) => (
    <section className="lnk-aim__proof">
        <div className="lnk-aim__wrap lnk-aim__proof-grid">
            <div>
                <div className="lnk-aim__title-block">
                    <Typography variant="h2">{content.title}</Typography>
                    <BottomBorder width={69} addMargin={false}/>
                </div>
                {/* pre-line: an Enter in the admin's textarea is a line break here */}
                <p style={{whiteSpace: "pre-line"}}>{content.body}</p>
            </div>

            <div className="lnk-aim__proof-card">
                <div className="lnk-aim__proof-icon">
                    <div className="lnk-aim__proof-box">
                        <svg className="lnk-aim__icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M6 3h8l4 4v14H6z"/>
                            <path d="M14 3v4h4"/>
                            <path d="M9 12h6M9 16h4"/>
                        </svg>
                    </div>
                    <div className="lnk-aim__proof-label">תוכן מקצועי</div>
                </div>

                <div className="lnk-aim__proof-arrow" aria-hidden="true">›</div>

                <div className="lnk-aim__proof-icon">
                    <div className="lnk-aim__proof-box">
                        <svg className="lnk-aim__icon" viewBox="0 0 24 24" aria-hidden="true">
                            <circle cx="12" cy="12" r="9"/>
                            <path d="M8 12l2.5 2.5L16 9"/>
                        </svg>
                    </div>
                    <div className="lnk-aim__proof-label">פרסום ואינדוקס</div>
                </div>

                <div className="lnk-aim__proof-arrow" aria-hidden="true">›</div>

                <div className="lnk-aim__proof-icon">
                    <div className="lnk-aim__proof-box lnk-aim__proof-box--final">
                        <svg className="lnk-aim__icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 2l3 6 6 3-6 3-3 6-3-6-6-3 6-3z"/>
                        </svg>
                    </div>
                    <div className="lnk-aim__proof-label">אזכור ב-AI</div>
                </div>
            </div>
        </div>
    </section>
);

export default Proof;
